import { cloneElement } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import type { FC } from 'react';
import type { ControllerProps } from 'react-hook-form';

export interface FieldControlProps {
  children:
    | ControllerProps['render']
    | React.ReactElement<{ key: string } & Parameters<ControllerProps['render']>[0]>;
  name: ControllerProps['name'];
}

export const FieldControl: FC<FieldControlProps> = ({
  children,
  name,
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={typeof children === 'function'
        ? children
        : (props) => cloneElement( children, { key: name, ...props } )}
    />
  );
};
